import React from 'react'
import PropTypes from 'prop-types'
import {CardPrimaryAction as RmwcCardPrimaryAction} from '@rmwc/card'
import '@rmwc/card/styles'

const CardPrimaryAction = ({children, ...otherProps}) => <RmwcCardPrimaryAction {...otherProps}>{children}</RmwcCardPrimaryAction>

CardPrimaryAction.propTypes = {
  children: PropTypes.any
}

export {CardPrimaryAction}
